import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError } from '../util/util.web'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('responseParser data', data)
  if (data?.status === 'SUCCESS') return data
  else throw getNetworkResponseError(data)
}

const updateKycConsentApi = (requestBody: any) => {
  console.log('2')
  const request: Request<{}> = {
    apiPath: APIEndPoints.kycConsentApi,
    method: 'POST',
    config: sitConfig(RootStore.user.session.getTokens),
    body: requestBody,
  }
  return executeRequest(request).then((data) => {
    console.log('executeRequest data', data)
    return responseParser(data.data)
  })
}

export { updateKycConsentApi }
